var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
export class Mutex {
    constructor() {
        this.waiting = [];
        this.locked = false;
    }
    lock() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.locked) {
                yield new Promise(res => {
                    this.waiting.push(res);
                });
            }
            this.locked = true;
        });
    }
    unlock() {
        var _a;
        if (!this.locked) {
            return;
        }
        this.locked = false;
        (_a = this.waiting.shift()) === null || _a === void 0 ? void 0 : _a();
    }
}
export const DeepClone = (_a = window.structuredClone) !== null && _a !== void 0 ? _a : ((data) => JSON.parse(JSON.stringify(data)));
export function DeepCompare(first, second, numEps = 0) {
    // Check if the types and values of the two arguments are the same.
    if (first === second) {
        return true;
    }
    // Check if any arguments are null.
    if (first === null || second === null) {
        return false;
    }
    // Check if numbers are close enough.
    if (typeof first === "number" && typeof second === "number" && Math.abs(first - second) < numEps) {
        return true;
    }
    // Check if any argument is none object.
    if (typeof first !== "object" || typeof second !== "object") {
        return false;
    }
    // Extract the properties of the two objects.
    let firstKeys = Object.getOwnPropertyNames(first);
    let secondKeys = Object.getOwnPropertyNames(second);
    // Check if the objects contain the same number of properties (We might be more permissive to allow first object to be "subset" of second).
    if (firstKeys.length !== secondKeys.length) {
        return false;
    }
    // Iterating through all the properties of the first object.
    for (let key of firstKeys) {
        // Making sure that every property in the first object also exists in second object.
        if (!Object.hasOwn(second, key)) {
            return false;
        }
        // Compare the properties recursively.
        if (DeepCompare(first[key], second[key], numEps) === false) {
            return false;
        }
    }
    return true;
}
export function ForEachSide(callback) {
    return [callback(0 /* FootSide.Left */), callback(1 /* FootSide.Right */)];
}
export function GetOtherSide(side) {
    return side === 0 /* FootSide.Left */ ? 1 /* FootSide.Right */ : 0 /* FootSide.Left */;
}
//# sourceMappingURL=util.js.map